module.exports = __webpack_public_path__ + "img/ybzdywjg_charact_5.3de9c172.svg";